module.exports = __webpack_public_path__ + "img/hill.42fadedb.png";